<template>
  <div>
    <b-breadcrumb :items="breadCrumbs" />

    <div class="row">
      <div class="col-6 offset-3">
        <b-form @submit.prevent="search">
          <b-input-group class="mb-3" prepend="Find Payments">
            <b-form-input
              v-model="searchTerm"
              placeholder="Type customer name or amount to search"
            />
            <b-input-group-append>
              <b-btn text="Button" type="submit" variant="success">Find</b-btn>
              <b-btn
                text="Button"
                type="button"
                variant="default"
                @click="clear"
                >Clear</b-btn
              >
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </div>
    </div>

    <b-row class="mt-3" v-if="orders && orders.unpaid.length">
      <b-col md="12">
        <h2 v-if="orders.unpaid.length > 0">Unpaid Orders</h2>
        <b-table :items="orders.unpaid" :fields="fields" small>
          <template slot="cell(name)" slot-scope="row">{{
            row.item.firstname + " " + row.item.lastname
          }}</template>

          <template slot="cell(total)" slot-scope="row">{{
            (Math.round(row.item.total * 100) / 100).toFixed(2)
          }}</template>

          <template slot="cell(order_status_name)" slot-scope="row">
            <span :class="orderStatusClass(row.item.order_status_id)">
              {{ row.item.order_status_name }}

            </span>
          </template>

          <template slot="cell(totalInGBP)" slot-scope="row">{{
            (Math.round(row.item.totalInGBP * 100) / 100).toFixed(2)
          }}</template>


          <template slot="cell(actions)" slot-scope="row">
            <div style="width:150px;">
              <b-button
                size="sm"
                variant="primary"
                class="ml-2"
                :to="'/order/' + row.item.order_id"
                >View</b-button
              >
              <b-button
                size="sm"
                variant="warning"
                class="ml-2"
                @click="markPaid(row.item.order_id)"
                >Mark Paid</b-button
              >
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="orders && orders.paid.length">
      <b-col md="12">
        <h2>Paid Orders</h2>
        <b-table :items="orders.paid" :fields="fields" small>
          <template slot="cell(total)" slot-scope="row">{{
            (Math.round(row.item.total * 100) / 100).toFixed(2)
          }}</template>
          <template slot="cell(totalInGBP)" slot-scope="row">{{
            (Math.round(row.item.totalInGBP * 100) / 100).toFixed(2)
          }}</template>

          <template slot="cell(name)" slot-scope="row">{{
            row.item.firstname + " " + row.item.lastname
          }}</template>

          <template slot="cell(order_status_name)" slot-scope="row">
            <span :class="orderStatusClass(row.item.order_status_id)">
              {{ row.item.order_status_name }}
            </span>
          </template>

          <template slot="cell(actions)" slot-scope="row">
            <div style="width:150px;">
              <b-button
                size="sm"
                variant="primary"
                class="ml-2"
                :to="'/order/' + row.item.order_id"
                >View</b-button
              >
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "payments",
  components: {},
  data() {
    return {
      orders: null,
      searchTerm: "",
      fields: [
        { key: "order_id", label: "#", sortable: true },
        { key: "date_added", label: "Date" },
        { key: "name", label: "Name" },
        { key: "currency_code", label: "Currency" },
        { key: "bank_total", label: "Bank Total" },
        { key: "payment_method", label: "Method" },
        { key: "order_status_name", label: "Status" },
        { key: "actions", label: "" }
      ],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Payments", active: true }
      ]
    };
  },
  mounted: function() {},
  methods: {
    clear() {
      this.searchTerm = "";
      this.orders = null;
    },
    search() {
      let loader = this.$loading.show();
      //if search term is numberic
      if (!isNaN(parseFloat(this.searchTerm)) && isFinite(this.searchTerm)) {
        this.$http
          .post(this.APIURL + this.BRAND + "/payment/find-amount", {
            term: this.searchTerm.trim()
          })
          .then(
            response => {
              if (
                  response.data.paid.length == 0 &&
                  response.data.unpaid.length == 0
              ) {
                this.orders = null;
              } else {
                this.orders = response.data;
              }
              this.searchTerm = "";
              loader.hide();
            },
            () => {
              loader.hide();
              this.searchTerm = "";
              this.orders = null;
            }
          );
      } else {
        //if not
        this.$http
          .post(this.APIURL + this.BRAND + "/payment/find-customer", {
            term: this.searchTerm.trim()
          })
          .then(
            response => {
              if (
                response.data.paid.length == 0 &&
                response.data.unpaid.length == 0
              ) {
                console.log("here");
                this.orders = null;
              } else {
                this.orders = response.data;
              }
              this.searchTerm = "";
              loader.hide();
            },
            () => {
              loader.hide();
              this.searchTerm = "";
              this.orders = null;
            }
          );
      }
    },
    markPaid(orderID) {
      let loader = this.$loading.show();
      this.$http
        .post(this.APIURL + this.BRAND + "/payment/mark-paid", {
          "order-id": orderID
        })
        .then(
          () => {
            // this.$swal(
            //   "Success!",
            //   "Order marked as paid successfully!",
            //   "success"
            // );
            this.searchTerm = null;
            this.orders = null;
            loader.hide();
          },
          error => {
            loader.hide();
            console.log(error);
          }
        );
    },
    orderStatusClass: function (ordStatus) {
      if (ordStatus == "0" || ordStatus == "1") {
        return "bg-danger text-white shipping-red text-center";
      }
        if (ordStatus == "10") {
            return "bg-danger text-white shipping-red text-center";
        }
      if (ordStatus == "2") {
        return "bg-info text-white shipping-red text-center";
      }
      if (ordStatus == "3") {
        return "bg-primary text-white shipping-red text-center";
      }
      if (ordStatus == "17") {
        return "bg-success text-white shipping-red text-center";
      }
    },
    orderStatusText: function (ordStatus) {
      if (ordStatus == "0" || ordStatus == "1") {
        return "Pending";
      }
      if (ordStatus == "2") {
        return "Processing";
      }
      if (ordStatus == "3") {
        return "Shipping";
      }
      if (ordStatus == "17") {
        return "Shipped";
      }
    },
  }
};
</script>
